<template>
    <router-view/>
</template>

<script>
    import {EventBus} from '@/event-bus.js';

    export default {
        name: 'App',
        components: {},

        async created() {
            let autoAuthToken = this.$route.query.autoAuthToken;
            if (!!autoAuthToken) {
                await this.$store.dispatch('authByToken', autoAuthToken);

                let query = Object.assign({}, this.$route.query);
                delete query.autoAuthToken;
                this.$router.replace({ query });
            }
        },

        mounted() {
            let topOfContent = document.getElementsByTagName("head");
            if (!!topOfContent && topOfContent.length > 0) {
                topOfContent[0].scrollIntoView();
            }

            EventBus.$on('window-visibility-change', payload => {
                if (!!payload.visible) {

                    document.body.classList.add('overlay');
                } else {
                    document.body.classList.remove('overlay');
                }
            });
        }
    }
</script>

<style>
    @import 'font-awesome/css/font-awesome.min.css';
    /*@import 'css/natal-chart.css';*/
    @import 'css/style.css';
    @import 'css/animate.css';
    @import 'css/adaptive.css';
    @import 'css/style_dev.css';
</style>